import { inject } from '@angular/core';
import { CanMatchFn, Router } from '@angular/router';

import { map } from 'rxjs/operators';

import { AuthService } from '@core/auth/auth.service';

/** Protect lazy feature routes — redirect unauthenticated sessions to `/login`. */
export const authCanMatch: CanMatchFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);
  return auth.ensureAuthenticatedForNavigation().pipe(
    map((ok) =>
      ok ? true : router.createUrlTree(['/login'], { queryParams: { returnUrl: router.url } }),
    ),
  );
};
